import { useQuery } from '@tanstack/react-query'
import { getAggregatedPositions, getAggregatedRisk } from '@/lib/api'
import { queryKeys } from '@/lib/queryKeys'

export function useAggregatedPositions(assetClass?: string) {
  return useQuery({
    queryKey: queryKeys.aggregated.positions(assetClass),
    queryFn: () => getAggregatedPositions(assetClass),
    refetchInterval: 30_000,
  })
}

export function useAggregatedRisk() {
  return useQuery({
    queryKey: queryKeys.aggregated.risk(),
    queryFn: getAggregatedRisk,
    refetchInterval: 30_000,
  })
}
